export const smartDocStaticParamType_ChiefComplaint = 'chief-complaint';
//# sourceMappingURL=types.js.map